import { createContext } from "react"

//Context for Radiologist updation
export const RadiologistContext = createContext()

export default RadiologistContext